import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи правил ранжирования команд при равенстве очков. Ключ — `name` правила из настроек турнира. */
const RANKING_RULE_LABELS: Record<string, MessageDescriptor> = {
  ranking_points_personal_meetings: msg`Количество очков в личных встречах`,
  ranking_wins_personal_meetings: msg`Количество побед в личных встречах`,
  ranking_scored_conceded_diff_personal_meetings: msg`Разница забитых и пропущенных мячей в личных встречах`,
  ranking_scored_goals_personal_meetings: msg`Количество забитых мячей в личных встречах`,
  ranking_scored_conceded_diff_total: msg`Общая разница забитых и пропущенных мячей`,
  ranking_scored_goals_total: msg`Общее количество забитых мячей`,
  ranking_wins_total: msg`Количество побед`,
};

export function getRankingRuleLabel(name?: string | null): MessageDescriptor | undefined {
  return name ? RANKING_RULE_LABELS[name] : undefined;
}
